import { makeStyles } from '../../../styles';
export const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(1),
        borderRadius: theme.spacing(1),
    },
    copyArea: {
        borderRadius: theme.spacing(1),
        padding: theme.spacing(2),
        cursor: 'pointer',
        wordWrap: 'break-word',
        '&:hover': {
            background: theme.colors.gray[0],
        },
        '& > .MuiTypography-root': {
            lineHeight: theme.spacing(3.25),
            fontWeight: 600,
        },
    },
    tooltip: {
        backgroundColor: theme.colors.primary.contrastWhite,
        boxShadow: theme.shadows[2],
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    },
    arrow: {
        // these 2 important are needed due to mui applying some of its styling directly on element and there is no other way to override it
        left: '50% !important',
        transform: 'translateX(-50%) !important',
        color: theme.colors.primary.contrastWhite,
    },
    message: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        '& > .MuiTypography-root': {
            fontSize: 12,
            lineHeight: theme.spacing(2),
            fontWeight: 600,
            color: theme.colors.text[700],
        },
    },
    icon: {
        fontSize: 18,
    },
}));
//# sourceMappingURL=CopyContainer.styles.js.map